<article>
  <div #headerNavWrapper>
    <dgx-components-header
      class="header"
      [navigation]="navigationLinks"
      [clientLogo]="clientLogo"
    >
    </dgx-components-header>
  </div>

  <app-maintenance-banner> </app-maintenance-banner>

  <main>
    <div class="content">
      <ng-content></ng-content>
      <div
        class="content__router-outlet-wrapper"
        [@routeAnimations]="prepareRoute(outlet)"
      >
        <router-outlet #outlet="outlet"></router-outlet>
      </div>
    </div>
  </main>
  <dgx-pr-spa-footer class="footer"></dgx-pr-spa-footer>
</article>
